<template>
  <div class="Innovate-three">
      <div class="Image"><img src="@/assets/Innovate/three.png" alt=""></div>
  </div>
</template>

<script>
export default {}
</script>

<style scoped lang="less">
@import "../index.css";
.Innovate-three{
.Image {
    text-align: left;
    img {
      max-width: 930px;
      height: 454px;
      object-fit: cover;
    }
  }
}
</style>
